
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['close', 'remove', 'save'],
  setup() {
    return {};
  },
});
